export class UploaderResponseError extends Error {
  public interpolateParams?: Record<string, string>;

  constructor(message = "fileUploader.somethingIsWrong") {
    super(message);
    this.name = this.constructor.name;
  }
}
